import { $Form } from './Form.parts';
import type { FormProps } from './Form.types';

export function Form(props: FormProps & { className?: string }) {
	return (
		<$Form
			className={props.className}
			onSubmit={(e) => {
				e.preventDefault();
				props.onSubmit();
			}}
			ref={props._ref}
		>
			{props.children}
		</$Form>
	);
}
